module.exports = __webpack_public_path__ + "img/ag.cd1d1172.svg";